var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Line/General/edit-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M15.0007 8.33375L11.6673 5.00042M2.08398 17.9171L4.90429 17.6037C5.24887 17.5654 5.42115 17.5463 5.58219 17.4942C5.72506 17.4479 5.86102 17.3826 5.98639 17.2999C6.1277 17.2067 6.25027 17.0841 6.49542 16.839L17.5007 5.83375C18.4211 4.91328 18.4211 3.42089 17.5007 2.50041C16.5802 1.57994 15.0878 1.57994 14.1673 2.50041L3.16209 13.5056C2.91694 13.7508 2.79436 13.8734 2.70118 14.0147C2.61851 14.14 2.55316 14.276 2.50691 14.4189C2.45478 14.5799 2.43564 14.7522 2.39735 15.0968L2.08398 17.9171Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit02);
export default __webpack_public_path__ + "static/media/edit-02.c1131c8b853b949adb2758d9dc3e61d7.svg";
export { ForwardRef as ReactComponent };